@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

@layer chart {
  .viewControllerRoot {
    display: flex;
    justify-content: left;
    padding: 10px 20px 10px 10px;
    gap: 8px;
    min-height: 56px;

    &.isSimpleChart {
      justify-content: space-between;
      padding: 10px 0;
    }
  }

  .flexWrapper {
    display: flex;
    gap: 4px;
  }

  .viewControllerRoot button.clearAllChartsButton {
    height: auto;
    @include typography-v2-title-sm;
    @include border-radius-r2;
    color: var(--text-primary);
    margin-left: auto;
  }
}
